export default __webpack_public_path__ + "static/48-100-fb59ea5e867368b31cfdd1239303fb9d.jpg";